export const CRASH_KINDS = ['render', 'global', 'unhandled-rejection'];
export const CRASH_PLATFORMS = ['android', 'ios', 'web'];
/** The size limits of one report and of one batch (the phone cuts to them; the server cuts again). */
export const CRASH_LIMITS = {
    /** Reports in one batch. */
    maxReports: 10,
    message: 300,
    name: 80,
    stack: 2_000,
    componentStack: 2_000,
    app: 31,
    appVersion: 32,
    updateId: 64,
    idempotencyKey: 64,
    /** The largest request body the route accepts (bytes). */
    maxBodyBytes: 64 * 1024,
};
/** Mask what an error message may quote from a person: e-mail addresses and runs of 8+ digits. */
export function redactCrashText(text) {
    return text
        .replace(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, '<email>')
        .replace(/\+?\d[\d\s().-]{6,}\d/g, (run) => (run.replace(/\D/g, '').length >= 8 ? '<digits>' : run));
}
const cut = (text, max) => (text.length > max ? `${text.slice(0, max)}…` : text);
/**
 * The shape a report is stored in, or `undefined` when it is not a report at all. Total: every text is redacted and cut; an unknown kind or a missing
 * message refuses the report (the route answers 400 for the batch). Used by the API on every incoming report and by the phone before it queues one.
 */
export function sanitizeCrashReport(raw, now = Date.now) {
    if (typeof raw !== 'object' || raw === null || Array.isArray(raw))
        return undefined;
    const o = raw;
    if (typeof o.kind !== 'string' || !CRASH_KINDS.includes(o.kind))
        return undefined;
    if (typeof o.message !== 'string' || o.message.trim() === '')
        return undefined;
    const text = (v, max) => (typeof v === 'string' && v !== '' ? cut(redactCrashText(v), max) : undefined);
    const at = typeof o.at === 'string' && Number.isFinite(Date.parse(o.at)) ? new Date(Date.parse(o.at)).toISOString() : new Date(now()).toISOString();
    const name = text(o.name, CRASH_LIMITS.name);
    const stack = text(o.stack, CRASH_LIMITS.stack);
    const componentStack = text(o.componentStack, CRASH_LIMITS.componentStack);
    return {
        kind: o.kind,
        message: cut(redactCrashText(o.message), CRASH_LIMITS.message),
        ...(name !== undefined ? { name } : {}),
        ...(stack !== undefined ? { stack } : {}),
        ...(componentStack !== undefined ? { componentStack } : {}),
        ...(typeof o.fatal === 'boolean' ? { fatal: o.fatal } : {}),
        at,
    };
}
export class AppCrashReportsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Send a batch (signed in). A short timeout: a crash upload must never hold the app. */
    submit(input, timeoutMs = 8_000) {
        return this.client.request({ method: 'POST', path: '/v1/app/crash-reports', body: input, auth: true, timeoutMs });
    }
    /** The operator's read (`audit:inspect`, a global grant). */
    list(query = {}) {
        const params = new URLSearchParams();
        for (const [k, v] of Object.entries(query))
            if (v !== undefined)
                params.set(k, String(v));
        const qs = params.toString();
        return this.client.request({ method: 'GET', path: `/v1/ops/app-crash-reports${qs === '' ? '' : `?${qs}`}`, auth: true });
    }
}
//# sourceMappingURL=crash-reports.js.map